import {type ComponentProps} from "react";
import ReactMarkdown, {type Components} from "react-markdown";
import classNames from "classnames";

import {Link} from "@pg-design/link-module";
import {Text, type TextVariantUnionType} from "@pg-design/text-module";

import * as styles from "./MarkdownText.module.css";

interface IProps {
    markdown: string;
    variant?: TextVariantUnionType;
    className?: string;
}

const markdownComponents: Components = {a: MarkdownLink};

export const MarkdownText = ({markdown, variant = "body_copy_2", className}: IProps) => {
    return (
        <Text as="div" variant={variant} className={classNames(styles.markdownText, className)}>
            <ReactMarkdown allowedElements={allowedMarkdownElements} components={markdownComponents} skipHtml unwrapDisallowed>
                {markdown}
            </ReactMarkdown>
        </Text>
    );
};

function MarkdownLink({children, href}: ComponentProps<"a">) {
    return href ? (
        <Link href={href} target="_blank" rel="noopener noreferrer" size="inherit" underline>
            {children}
        </Link>
    ) : (
        <>{children}</>
    );
}

const allowedMarkdownElements = [
    "p",
    "strong",
    "b",
    "em",
    "i",
    "ul",
    "ol",
    "li",
    "a",
    "br",
    "blockquote",
    "code",
    "pre",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr"
];
import {type ComponentProps} from "react";
import ReactMarkdown, {type Components} from "react-markdown";
import classNames from "classnames";

import {Link} from "@pg-design/link-module";
import {Text, type TextVariantUnionType} from "@pg-design/text-module";

import * as styles from "./MarkdownText.module.css";

interface IProps {
    markdown: string;
    variant?: TextVariantUnionType;
    className?: string;
}

const markdownComponents: Components = {a: MarkdownLink};

export const MarkdownText = ({markdown, variant = "body_copy_2", className}: IProps) => {
    return (
        <Text as="div" variant={variant} className={classNames(styles.markdownText, className)}>
            <ReactMarkdown allowedElements={allowedMarkdownElements} components={markdownComponents} skipHtml unwrapDisallowed>
                {markdown}
            </ReactMarkdown>
        </Text>
    );
};

function MarkdownLink({children, href}: ComponentProps<"a">) {
    return href ? (
        <Link href={href} target="_blank" rel="noopener noreferrer" size="inherit" underline>
            {children}
        </Link>
    ) : (
        <>{children}</>
    );
}

const allowedMarkdownElements = [
    "p",
    "strong",
    "b",
    "em",
    "i",
    "ul",
    "ol",
    "li",
    "a",
    "br",
    "blockquote",
    "code",
    "pre",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr"
];
